import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';

import ApiService from 'services/ApiService/ApiService';
import { STUDIO_ADMINS_URL } from 'pages/StudioRoster/Api';
import parseCatch from 'utils/parseCatch';


const UPDATE_ADMINISTRATORS = 'cam4/studio/settings/UPDATE_ADMINISTRATORS';
const REMOVE_ADMINISTRATOR = 'cam4/studio/settings/REMOVE_ADMINISTRATOR';
const SET_DELETE_MESSAGE = 'cam4/studio/settings/SET_DELETE_ERROR_MESSAGE';

export const NAME = 'administrators';

const initialState = Immutable.fromJS({
  administrators: [],
  snackBarMessage: '',
  errorCode: '',
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_ADMINISTRATORS:
      return state.set('administrators', action.administrators);

    case REMOVE_ADMINISTRATOR: {
      const administrators = state
        .get('administrators')
        .filter((administrator) => administrator !== action.administrator);

      return state.set('administrators', administrators);
    }

    case SET_DELETE_MESSAGE:
      return state.set('snackBarMessage', action.message);

    default:
      return state;
  }
}

function removeAdministrator(administrator) {
  return {
    type: REMOVE_ADMINISTRATOR,
    administrator,
  };
}

function updateAdministrators(administrators) {
  return {
    type: UPDATE_ADMINISTRATORS,
    administrators,
  };
}

function setErrorMessage(message) {
  return {
    type: SET_DELETE_MESSAGE,
    message,
  };
}

function dismissSnackBarCode() {
  return (dispatch) => dispatch(setErrorMessage(''));
}

function getAdministrators(studioOwnerName) {
  const URL = ApiService.substitute(STUDIO_ADMINS_URL, { studioOwnerName: encodeURIComponent(studioOwnerName) });

  return (dispatch) =>
    ApiService
      .get(URL)
      .then((res) => dispatch(updateAdministrators(res.data)))
      .catch((error) => parseCatch(error, true));
}

function deleteAdministrator(studioOwnerName, administrator) {
  const URL =
  `${ApiService.substitute(STUDIO_ADMINS_URL, { studioOwnerName: encodeURIComponent(studioOwnerName) })
  }/${
    encodeURIComponent(administrator.username)}`;

  return (dispatch) =>
    ApiService
      .delete(URL)
      .then(
        (res) => dispatch(removeAdministrator(administrator)) && dispatch(setErrorMessage(res.data)),
        (error) => parseCatch(error, true)
      );
}

const administrators = (state) => state[NAME].get('administrators');
const snackBarMessage = (state) => state[NAME].get('snackBarMessage');

export const actionCreators = {
  deleteAdministrator,
  getAdministrators,
  dismissSnackBarCode,
};

export const selector = createStructuredSelector({
  administrators,
  snackBarMessage,
});
